import { z } from 'zod';
export const LiveBillQuerySchema = z.object({
    customer_id: z.string(),
    from_date: z.string().optional(),
    to_date: z.string().optional(),
});
const LiveBillPeriodSchema = z.object({
    start: z.string().datetime(),
    end: z.string().datetime(),
    days_elapsed: z.number(),
    days_remaining: z.number(),
    reset_date: z.string().datetime(),
});
const LiveBillSummarySchema = z.object({
    included_used_usd: z.number(),
    included_total_usd: z.number(),
    included_pct: z.number(),
    overage_usd: z.number(),
    total_revenue_usd: z.number(),
    total_cost_usd: z.number(),
    margin_usd: z.number(),
    margin_pct: z.number().nullable(),
    projected_total_usd: z.number(),
});
const LiveBillSignalSchema = z.object({
    signal_id: z.string(),
    signal_name: z.string(),
    action_type: z.string(),
    quantity: z.number(),
});
const LiveBillAgentSchema = z.object({
    agent_id: z.string(),
    agent_name: z.string(),
    last_activity: z.string().datetime().nullable(),
    revenue_usd: z.number(),
    cost_usd: z.number(),
    margin_usd: z.number(),
    margin_pct: z.number().nullable(),
    tasks: z.number(),
    workflows: z.number(),
    outcomes: z.number(),
    top_signals: z.array(LiveBillSignalSchema),
});
const LiveBillLineItemSchema = z.object({
    agent_id: z.string(),
    agent_name: z.string(),
    signal_name: z.string(),
    action_type: z.string(),
    quantity: z.number(),
    unit_price_usd: z.number(),
    revenue_usd: z.number(),
    cost_usd: z.number(),
    is_overage: z.boolean(),
});
export const LiveBillResponseSchema = z.object({
    period: LiveBillPeriodSchema,
    summary: LiveBillSummarySchema,
    agents: z.array(LiveBillAgentSchema),
    line_items: z.array(LiveBillLineItemSchema),
    has_contract: z.boolean(),
    cached_at: z.string().datetime(),
});
//# sourceMappingURL=live-bill.schema.js.map